import { gql } from '@apollo/client'

export const FIND_ALL_AI_TEST_TRAINING_DATA_HISTORY = gql`
  query findAllAiTestTrainingDataHistory($query: AiTestTrainingDataHistoryQueryInput!) {
    findAllAiTestTrainingDataHistory(query: $query) {
      count
      items {
        id
        createdAt
        status
        errorMessage
      }
    }
  }
`
